<template>
  <div class="data-others__container">
    <JadeGroupHeader>{{ $t('title') }}</JadeGroupHeader>

    <JadeListItem
      v-if="data.attemptCount >= 0"
      :label="$t('card.attempt-count')"
      :trailing="data.attemptCount"
    />

    <JadeDivider v-if="data.attemptCount >= 0" />

    <JadeDivider v-if="data.description" />

    <JadeListItem
      v-if="data.description"
      :label="$t('cash.description')"
      :trailing="data.description"
    />

    <JadeDivider v-if="data.nextAttempt" />

    <JadeListItem
      v-if="data.nextAttempt"
      :label="$t('card.next-attempt')"
      :trailing="data.nextAttempt | dateFormat('dateAndHour')"
    />

    <JadeDivider v-if="data.paidAtDate" />

    <JadeListItem
      v-if="data.paidAtDate"
      :label="$t('boleto.paid-at')"
      :trailing="data.paidAtDate | dateFormat('date')"
    />

    <JadeDivider v-if="data.paidAtDateHour" />

    <JadeListItem
      v-if="data.paidAtDateHour"
      :label="$t('boleto.paid-at')"
      :trailing="data.paidAtDateHour | dateFormat('dateAndHour')"
    />

    <JadeDivider v-if="data.captureMethod" />

    <JadeListItem
      v-if="data.captureMethod"
      :label="$t('capture-method.title')"
      :trailing="$t(`capture-method.${data.captureMethod}`)"
    />

    <JadeDivider v-if="data.deviceSerialNumber" />

    <JadeListItem
      v-if="data.deviceSerialNumber"
      :label="$t('capture-method.terminal-number')"
      :trailing="data.deviceSerialNumber"
    />

    <JadeDivider v-if="data.pgid" />

    <JadeListItem
      v-if="data.pgid"
      :label="$t('pix')"
      :trailing="data.pgid"
    />

    <JadeDivider v-if="data.endToEndId" />

    <JadeListItem
      v-if="data.endToEndId"
      :label="$t('pix-bacen')"
      :trailing="data.endToEndId"
    />

    <JadeDivider size="medium" />
  </div>
</template>

<script>
import { JadeGroupHeader, JadeDivider, JadeListItem } from '@jade'

export default {
  name: 'LayoutDataOther',

  components: {
    JadeGroupHeader,
    JadeDivider,
    JadeListItem
  },

  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.data-others__container hr.jade-divider:first-of-type {
  display: none;
}

.data-others__container hr.jade-divider:last-of-type {
  display: block;
}
</style>

<i18n>
  {
    "pt-BR": {
      "title": "Outros",
      "card": {
        "attempt-count": "Número de tentativas",
        "next-attempt": "Próxima tentativa"
      },
      "boleto": {
        "paid-at": "Pago em"
      },
      "cash": {
        "description": "Descrição"
      },
      "capture-method": {
        "title": "Método de captura",
        "contact": "Chip",
        "contact_emv": "Chip",
        "contactless": "Aproximação",
        "contactless_emv": "Aproximação",
        "mag-stripe": "Tarja magnética",
        "magstripe": "Tarja magnética",
        "terminal-number": "Número de terminal"
      },
      "pix": "ID Pix Pagar.me",
      "pix-bacen": "ID Pix Bacen"
    },
    "en-US": {
      "title": "Others",
      "card": {
        "attempt-count": "Attempt count",
        "next-attempt": "Next attempt"
      },
      "boleto": {
        "paid-at": "Paid at"
      },
      "cash": {
        "description": "Description"
      },
      "capture-method": {
        "title": "Capture method",
        "contact": "Chip",
        "contact_emv": "Chip",
        "contactless": "Contactless",
        "contactless_emv": "Contactless",
        "mag-stripe": "Magnetic stripe",
        "magstripe": "Magnetic stripe",
        "terminal-number": "Teminal number"
      },
      "pix": "ID Pix Pagar.me",
      "pix-bacen": "ID Pix Bacen"
    }
  }
</i18n>
